<script setup>
const props = defineProps({
    initialValue: {
        type: Array,
        default: null
    }
})
const emits = defineEmits(['updateFilter'])

const modelValue = ref(false)
const updateFilter = (newValue) => {
    emits('updateFilter', newValue)
}

const filterValues = ref([])

onMounted(() => {
    if (props.initialValue) {
        filterValues.value = props.initialValue
    }
})

watch(filterValues, (newValue) => {
    updateFilter(newValue)
})
</script>
<template>
    <div class="single-filter-ui d-flex">
        <v-checkbox v-model="filterValues" label="Yes" value="true" class="ml-0"></v-checkbox>
        <v-checkbox v-model="filterValues" label="No" value="false" class="ml-3"></v-checkbox>
    </div>
</template>
